import dataReducer from './reducer_data';
import searchReducer from './reducer_search';

export default function rootReducer(state,action){
    return {
        ...state,
        data: dataReducer(state.data, action),
        search: searchReducer(state.search, action),
    }
}